namespace Matrix.Visualizer {
    export interface GraphNodeRow {
        NodeId?: number;
        GraphInstanceId?: number;
        NodeKey?: string;
        Caption?: string;
        Tooltip?: string;
        ShapeName?: string;
        BorderColour?: string;
        BackgroundColour?: string;
        TextColour?: string;
        TextFont?: string;
        TextAlign?: string;
        TextUnderline?: boolean;
        ContextMenuTemplate?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        GraphInstanceInstanceKey?: string;
        GraphInstanceGraphKey?: string;
        GraphInstanceThemeKey?: string;
        GraphInstanceRowId?: number;
    }

    export namespace GraphNodeRow {
        export const idProperty = 'NodeId';
        export const nameProperty = 'NodeKey';
        export const localTextPrefix = 'Visualizer.GraphNode';
        export const lookupKey = 'Visualizer.GraphNode';

        export function getLookup(): Q.Lookup<GraphNodeRow> {
            return Q.getLookup<GraphNodeRow>('Visualizer.GraphNode');
        }
        export const deletePermission = 'DataAdmin:Visualizer';
        export const insertPermission = 'DataAdmin:Visualizer';
        export const readPermission = 'Read:Visualizer';
        export const updatePermission = 'DataAdmin:Visualizer';

        export declare const enum Fields {
            NodeId = "NodeId",
            GraphInstanceId = "GraphInstanceId",
            NodeKey = "NodeKey",
            Caption = "Caption",
            Tooltip = "Tooltip",
            ShapeName = "ShapeName",
            BorderColour = "BorderColour",
            BackgroundColour = "BackgroundColour",
            TextColour = "TextColour",
            TextFont = "TextFont",
            TextAlign = "TextAlign",
            TextUnderline = "TextUnderline",
            ContextMenuTemplate = "ContextMenuTemplate",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            GraphInstanceInstanceKey = "GraphInstanceInstanceKey",
            GraphInstanceGraphKey = "GraphInstanceGraphKey",
            GraphInstanceThemeKey = "GraphInstanceThemeKey",
            GraphInstanceRowId = "GraphInstanceRowId"
        }
    }
}
